import React from 'react';
import Modal from 'react-modal';

if (typeof document !== 'undefined') {
  const appRoot = document.querySelector('#root');
  if (appRoot) {
    Modal.setAppElement(appRoot);
  }
}

export const BaseModal = ({ children, visible, className = '', overlayClassName = '', style = {}, onClose = () => {} }) => {
  return (
    <Modal
      isOpen={visible}
      overlayClassName={`absolute inset-0 z-top bg-black bg-opacity-80 flex justify-center overflow-hidden ` + overlayClassName}
      className={'outline-none overflow-hidden ' + className}
      style={{ content: style }}
      onRequestClose={onClose}
    >
      {children}
    </Modal>
  );
};
